<template>
    <div>   
        <div  class='row no-wrap justify-end q-mr-lg q-mt-md q-mb-lg desktop-only' >
            <q-btn label='Распечатать' @click='printList' icon='print' color='positive'/>
        </div>

        <div>
            <div v-for='(item, key) in materialTypes' :key=key class='bg-white shadow-1 q-mb-md'>
                    <div class='bg-primary text-white q-title q-pa-md'>
                        {{item.name}}
                    </div>
                    <div v-for='(n, key2) in getNomenklaturaByType(item.id)' :key=key2>
                        <div class='row no-wrap nomeklatura-line q-pa-sm text-faded q-body-2 items-center' v-bind:class="{'q-caption':$q.screen.lt.md}">
                            <div class='col-xs-7 col-sm-7 col-md-4'>
                                <div class='ellipsis-3-lines'>{{item.name}}</div>
                                <div class='q-caption ellipsis-3-lines'>{{n.name}}</div>
                            </div>
                            <div class='col-xs-2 col-sm-2 ellipsis-3-lines'>
                                {{n.width}} м
                            </div>
                            <div class='col-xs-3 col-sm-2 ellipsis-3-lines'>
                                {{n.count}} м.п.
                            </div>
                        </div>
                        <div class="separator-line"></div>
                    </div>
            </div>
        </div>
        <div id='materialList' style='padding:50px; display: none;'>
            <h1>Наличие материалов на складе</h1>
            <div v-for='(item, key) in materialTypes' :key=key>

                    <div class='row no-wrap text-white q-title' style='background:black; margin-top : 10px;'>
                        <div style='margin-left:50px'>{{item.name}}</div>
                    </div>      
                    <div v-for='(n, key2) in getNomenklaturaByType(item.id)' :key=key2 class='row no-wrap q-pa-sm items-center' style='border-bottom:1px dotted black; background:white;'>
                        <div class='col-6'>
                            <div>{{item.name}}</div>
                            <div>{{n.name}}</div>
                        </div>
                        <div class='col-3'>
                           {{n.width}} м
                        </div>
                        <div class='col-3'>
                            {{n.count}} м.п.
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    name : 'nomenklaturaList',

    created() {

    },
    computed : {

        materialTypes() {
            let q = this.$store.getters.getAllMaterials;
            return q;
            // return q.sort((a,b)=> {
            //     if (a.name>b.name) return 1;
            //     if (a.name>b.name) return -1;
            //     return 0;
            // });
        }
    },
    methods : {
        
        printList() {
            this.$htmlToPaper('materialList');
        },

        getMaterialName(id) {
            let q = this.$store.getters.getMaterialById(id);
            return q != null ? q.name : 'Не определен';
        },

        getNomenklaturaByType(id) {
            return this.$store.getters.getNomenklaturaByType(id);
        }
    },
}
</script>
<style lang="scss" scoped>
    .nomeklatura-line {
        cursor:pointer;
        &:hover {
            background-color: rgb(213, 255, 213) !important;
        }
    }
    .separator-line {
        height:1px;
        border-bottom: 1px solid rgb(184, 184, 184);

    }
</style>


